import { render } from "./Greeting.vue?vue&type=template&id=46dfb9dc&scoped=true"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"

import "./Greeting.vue?vue&type=style&index=0&id=46dfb9dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-46dfb9dc"

export default script